import React from 'react';
import {View} from 'react-native';

import BaseFeedCard from '../FeedCard/BaseFeedCard';
import {styles} from '../FeedCard/common.styles';
import Icon from '@/components/Icon';
import Space from '@/components/Space';
import Text from '@/components/Text';
import {useAppDispatch} from '@/hooks/useRedux';
import {setOnboardingInfo} from '@/store/user';
import {useThemedStyles} from '@/theme';
import {analytics} from '@/utils/analytics';

import OnboardingActions from './OnboardingActions';

const SpyWelcomeCard: React.FC = () => {
  const style = useThemedStyles(styles);
  const dispatch = useAppDispatch();

  const onClose = () => {
    dispatch(
      setOnboardingInfo({key: 'showFeedOnboardingSpyWelcome', value: false}),
    );
    analytics.feedOnboardingCompleted('spyWelcome');
  };

  return (
    <BaseFeedCard>
      <View style={style.imageContainer}>
        <Space p="s" style={style.featureContainer}>
          <Icon
            name="personSearch"
            provider="custom"
            style={style.featureIcon}
            size={80}
          />
          <Space pb="m" />
          <Text
            id="feed.onboardingSpyWelcome.title"
            weight="bold"
            style={style.centeredText}
          />
          <Space mb="xxs" />
          <Text
            id="feed.onboardingSpyWelcome.body"
            style={style.centeredText}
          />
        </Space>
      </View>

      <OnboardingActions onClose={onClose} />
    </BaseFeedCard>
  );
};

export default SpyWelcomeCard;
